export const ACCESS_TOKEN_KEY = 'access_token_key';
export const REFRESH_TOKEN_KEY = 'refresh_token_key';
export const ACTIVE_AUTH_METHOD = 'active_auth_method';
export const REDIRECT_URL = 'redirect_url';
export const CAMERA_RESOLUTION = 'camera_resolution';
export const CAMERA_DEVICE_ID = 'camera_device_id';
export const LANG_CODE_KEY = 'lang_code_key';
export const NAVIGATION_STATE_KEY = 'navigation_state_key';
